import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, useMediaQuery } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { cutString } from '../../../../../utils/Generator';
import './BreadCrumbs.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    justifyContent: 'center',
    display: 'inline-block',
    width: '100%',
    paddingRight: 300,
    '@media (max-width: 768px)': {
      paddingRight: 50,
    },
  },
  paper: {
    padding: theme.spacing(1, 2),
    backgroundColor: '#f6f8fb',
  },
}));

export default function BreadcrumbsA(props) {

  const classes = useStyles();
  const { postTitle, postCategory } = props;
  const isMobile = useMediaQuery('(max-width: 768.98px)')

  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        <ol
          itemScope
          itemType='http://schema.org/BreadcrumbList'
          className='BreadCrumbs_history'
        >
          <li
            itemScope
            itemProp="itemListElement"
            itemType="http://schema.org/ListItem"
            className='BreadCrumbs_history-first'
          >
            <Link
              itemProp="item"
              className='BreadCrumbs_history-first'
              to="/articulos"
            >
              <span itemProp="name">
                Artículos
              </span>
            </Link>
            <meta itemProp="position" content="1" />
          </li>
          {postCategory ?
            <li
              itemScope
              itemProp="itemListElement"
              itemType="http://schema.org/ListItem"
              className='BreadCrumbs_history-firstLi'
            >
              <img
                alt='back'
                src='/img/arrows/arrow-right.svg'
                className='BreadCrumbs_history-arrowRight'
              />
              <Link
                itemProp="item"
                className={
                  postTitle ?
                  'BreadCrumbs_history-start' :
                  'BreadCrumbs_history-last'
                }
                to={`/articulos/${postCategory}`}
              >
                <span itemProp="name">
                  {isMobile ?
                    cutString(10, postCategory) :
                    postCategory
                  }
                </span>
              </Link>
              <meta itemProp="position" content="2" />
            </li> : null
          }
          {postTitle ?
            <li
              itemScope
              itemProp="itemListElement"
              itemType="http://schema.org/ListItem"
              className='BreadCrumbs_history-secondLi'
            >
              <img
                alt='back'
                src='/img/arrows/arrow-right.svg'
                className='BreadCrumbs_history-arrowRight'
              />
              <Link itemProp="item" className='BreadCrumbs_history-last'>
                <span itemProp="name">
                  {isMobile ?
                    cutString(10, postTitle) :
                    postTitle
                  }
                </span>
              </Link>
              <meta itemProp="position" content="3" />
            </li> : null
          }
        </ol>
      </Paper>
    </div>
  );
}
